import { render, staticRenderFns } from "./PageApplication.vue?vue&type=template&id=21f89fc2&scoped=true"
import script from "./PageApplication.vue?vue&type=script&lang=js"
export * from "./PageApplication.vue?vue&type=script&lang=js"
import style0 from "./PageApplication.vue?vue&type=style&index=0&id=21f89fc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f89fc2",
  null
  
)

export default component.exports